import src from "IMAGE";
export default { src, width: 1133, height: 422, blurWidth: 8, blurHeight: 3, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAYAAACuyE5IAAAARElEQVR42i3KoQ5AUBhA4du8gJcQRZIgiIKpks1GMuPxf9/dbvh2ykkR0fKw8/FysTGkMpz0rBzcjFR5aFiYmUrz2FH/iLRPFCM/xTQAAAAASUVORK5CYII="};
